import React, {useMemo} from 'react';
import {getRoutes} from 'app-routes';
import UserPanel from '../user-panel/UserPanel';
import Button from 'devextreme-react/button';
import {useAuth} from '../../contexts/auth';
import './Header.scss';

export default function Header() {
  const {user} = useAuth();
  const routes = useMemo(() => getRoutes(user?.Rights), [user]);

  return (
    <header className={'header-component'}>
      <div className={'topbar-menu'}>
        {routes.map(route => {
          return (
            <a key={route.path} href={`#${route.path}`}>{route.text}</a>
          );
        })}
      </div>
      <div className={'box right-content'}>
        <Button
          className={'user-button authorization'}
          focusStateEnabled={false}
          activeStateEnabled={false}
          hoverStateEnabled={false}
          height={'100%'}
          stylingMode={'text'}
        >
          <UserPanel menuMode={'context'}/>
        </Button>
      </div>
    </header>
  )
}
